import React from "react";
import { observer } from "mobx-react-lite";
import CompetitionBilling from "../../Games/CompetitionBilling";

const CompetitionBillingManager = () => {
  return <CompetitionBilling role="MGR" />;
};

export default observer(CompetitionBillingManager);